module.exports = __webpack_public_path__ + "static/media/ipofit.77857ca0.png";